import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-less",
  "use": "icon-less-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" fill=\"#ffff\" id=\"icon-less\"><path d=\"M200-440v-80h560v80H200Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol